import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: null,
  currentContent: null,
  currentIndexContent: 0,
  sessionId: '',
  messages: [],
  isRecording: false,
  isLoadingBot: false,
  isDisableBtn: true,
  isFinish: false,
  isShowFooter: true,
  isShowSample: false,
  practiceData: null,
  numberRecorded: 0,
  introductionData: null,
  audioFileUser: null,
  audio: {},
}

export const learnPartThreeSlice = createSlice({
  name: 'learnPartThree',
  initialState,
  reducers: {
    updateData: (state, action) => {
      state.data = action.payload
    },
    updateCurrentContent: (state, action) => {
      state.currentContent = action.payload
    },
    updateCurrentIndexContent: (state, action) => {
      state.currentIndexContent = action.payload
    },
    updateSessionId: (state, action) => {
      state.sessionId = action.payload
    },
    updateMessages: (state, action) => {
      state.messages = action.payload
    },
    updateIsRecording: (state, action) => {
      state.isRecording = action.payload
    },
    updateIsLoadingBot: (state, action) => {
      state.isLoadingBot = action.payload
    },
    updateIsDisableBtn: (state, action) => {
      state.isDisableBtn = action.payload
    },
    updateIsFinish: (state, action) => {
      state.isFinish = action.payload
    },
    updateIsShowFooter: (state, action) => {
      state.isShowFooter = action.payload
    },
    updateIsShowSample: (state, action) => {
      state.isShowSample = action.payload
    },
    updatePracticeData: (state, action) => {
      state.practiceData = action.payload
    },
    updateNumberRecorded: (state, action) => {
      state.numberRecorded = action.payload
    },
    updateIntroductionData: (state, action) => {
      state.introductionData = action.payload
    },
    updateAudioFileUser: (state, action) => {
      state.audioFileUser = action.payload
    },
    updateAudio: (state, action) => {
      state.audio = action.payload
    },
    reset: state => {
      state.data = null
      state.currentContent = null
      state.currentIndexContent = 0
      state.messages = []
      state.isRecording = false
      state.sessionId = ''
      state.isLoadingBot = false
      state.isFinish = false
      state.isShowFooter = true
      state.isShowSample = false
      state.isDisableBtn = false
      state.practiceData = null
      state.numberRecorded = 0
      state.introductionData = null
      state.audio = {}
      state.audioFileUser = null
    },
  },
})

export const {
  updateData,
  updateCurrentContent,
  updateCurrentIndexContent,
  updateMessages,
  updateIsRecording,
  updateIsLoadingBot,
  updateSessionId,
  updateIsFinish,
  updateIsShowFooter,
  updateIsShowSample,
  updateIsDisableBtn,
  updatePracticeData,
  updateNumberRecorded,
  updateIntroductionData,
  updateAudioFileUser,
  updateAudio,
  reset,
} = learnPartThreeSlice.actions
export default learnPartThreeSlice.reducer
